module.exports = __webpack_public_path__ + "static/media/030_concepts_nk_2-07.3b7c0598.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/030_concepts_nk_2-07.png
// module id = 528
// module chunks = 0